import { html, LitElement, css, unsafeCSS } from "lit";
import styles from "./styles.css?inline";
import { template } from "./template";

export class HeaderDivider extends LitElement {
  render() {
    return html`${template(this)}`;
  }

  static styles = css`
  ${unsafeCSS(styles)}
`;
}
